/**
 * Which pages are drawn inside the admin app shell — the sidebar (AppSidebar)
 * beside the content slot (SidebarInset) — for the route gate
 * (components/auth/route-gate.tsx).
 *
 * The gate is mounted in the root layout, above every module layout, so it
 * cannot see whether the layout under it draws the shell. Where one does, the
 * gate hands its refusal (and its wait for the grants) to the shell's content
 * slot, and the sidebar stays (owner, 2026-10-06: a person refused a page must
 * be able to navigate away). Anywhere else it keeps the full-screen panel.
 *
 * One entry per top-level app directory whose own layout renders
 * `<SidebarInset>`. lib/auth/__tests__/route-shell.guard.spec.ts reads the
 * layouts on disk and fails when this list and they disagree: a directory
 * listed without a slot would show NO refusal (the page would render), and a
 * shell left out would lose its sidebar on refusal.
 */
export const SHELL_ROOTS: readonly string[] = [
  'announcements',
  'company-dashboard',
  'content-studio',
  'dashboard',
  'er',
  'esa',
  'feedback',
  'gamification',
  'jit-training',
  'lms',
  'phishing',
  'phishtrainer',
  'policies',
  'recipients',
  'reports',
  'review-queue',
  'settings',
  'smishing',
  'surveys',
  'vcro',
  'vishing',
  'workflows',
]

/** Is the page at `pathname` drawn inside the app shell? (Query and hash ignored.) */
export function routeHasShell(pathname: string): boolean {
  const first = pathname.split(/[?#]/)[0].split('/').filter(Boolean)[0]
  return first !== undefined && SHELL_ROOTS.includes(first)
}
